const translations = {
  // Navbar
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.track': 'Track Shipment',
  'nav.about': 'About',
  'nav.contact': 'Contact',
  'nav.trackNow': 'Track Now',

  // Footer
  'footer.tagline': 'Trusted by thousands of businesses worldwide for reliable, real-time shipment tracking and delivery.',
  'footer.quickLinks': 'Quick Links',
  'footer.contactUs': 'Contact Us',
  'footer.globalNumbers': 'Global Numbers',
  'footer.uk': 'United Kingdom',
  'footer.usa': 'United States',
  'footer.canada': 'Canada',
  'footer.allRightsReserved': 'All rights reserved.',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.cookies': 'Cookie Policy',

  // Hero
  'hero.badge': 'TRUSTED BY 50,000+ BUSINESSES WORLDWIDE',
  'hero.headline1': 'Delivering The World,',
  'hero.headline2': 'On Time',
  'hero.subtext': 'Real-time shipment tracking across air, land, and sea. Know exactly where your cargo is — every mile of the journey.',
  'hero.placeholder': 'Enter tracking number (e.g. SWT-2024-001847)',
  'hero.trackBtn': 'Track Shipment',
  'hero.tryLabel': 'Try:',
  'hero.scroll': 'Scroll to explore',
  'hero.stat1': 'Packages Delivered',
  'hero.stat2': 'Countries Served',
  'hero.stat3': 'On-Time Rate',
  'hero.stat4': 'Live Support',

  // Services Section
  'services.badge': 'Service Tiers',
  'services.title1': 'Choose Your',
  'services.title2': 'Shipping Plan',
  'services.subtitle': 'From budget-friendly economy shipping to white-glove same-day priority — we have the right service for every shipment.',
  'services.perShipment': 'Per Shipment',
  'services.monthlyPlan': 'Monthly Plan',
  'services.monthlySaving': 'Monthly plans save up to 35% compared to per-shipment pricing',
  'services.enterprise.title': 'Need a custom enterprise plan?',
  'services.enterprise.desc': 'Volume discounts, dedicated account managers, and custom SLAs for high-frequency shippers.',
  'services.enterprise.cta': 'Contact Sales',
  'services.perKg': 'per kg',
  'services.perMo': '/mo',
  'services.economy.name': 'Economy',
  'services.economy.tagline': 'Budget-friendly shipping',
  'services.economy.cta': 'Get Started Free',
  'services.economy.time': '5–7 Business Days',
  'services.standard.name': 'Standard',
  'services.standard.tagline': 'Reliable everyday delivery',
  'services.standard.cta': 'Choose Standard',
  'services.standard.time': '2–3 Business Days',
  'services.express.name': 'Express',
  'services.express.tagline': 'Fast-tracked delivery',
  'services.express.cta': 'Choose Express',
  'services.express.time': 'Next Business Day',
  'services.express.badge': 'Most Popular',
  'services.priority.name': 'Priority',
  'services.priority.tagline': 'Same-day white-glove service',
  'services.priority.cta': 'Choose Priority',
  'services.priority.time': 'Same Day (2h Window)',
  'services.priority.badge': 'Premium',
  'services.feat.basicTracking': 'Basic package tracking',
  'services.feat.emailNotif': 'Email delivery notification',
  'services.feat.20kg': 'Up to 20kg packages',
  'services.feat.insurance100': 'Standard insurance ($100)',
  'services.feat.liveMap': 'Live road map tracking',
  'services.feat.priority': 'Priority handling',
  'services.feat.smsAlerts': 'SMS & push alerts',
  'services.feat.signature': 'Signature on delivery',
  'services.feat.fullTracking': 'Full real-time tracking',
  'services.feat.emailSms': 'Email + SMS notifications',
  'services.feat.50kg': 'Up to 50kg packages',
  'services.feat.insurance500': 'Standard insurance ($500)',
  'services.feat.dedicatedDriver': 'Dedicated driver',
  'services.feat.emailSmsPush': 'Email + SMS + push alerts',
  'services.feat.100kg': 'Up to 100kg packages',
  'services.feat.insurance2000': 'Premium insurance ($2,000)',
  'services.feat.routeOpt': 'Route optimization',
  'services.feat.unlimitedWeight': 'Unlimited weight',
  'services.feat.insurance10000': 'Full insurance ($10,000)',
  'services.feat.dedicatedDriverAssigned': 'Dedicated driver assigned',

  // Tracking Page
  'track.title': 'Track Your Shipment',
  'track.subtitle': 'Enter your tracking number to see real-time status and delivery updates.',
  'track.placeholder': 'e.g. SWT-2024-001847',
  'track.scanBtn': 'Scan Code',
  'track.trackBtn': 'Track',
  'track.privacy': 'Your tracking number is private — only you can see your shipment details',
  'track.enter.title': 'Enter Your Tracking Number',
  'track.enter.desc': 'Your unique tracking number was emailed to you when your shipment was created. It looks like',
  'track.feature1': 'Real-time Updates',
  'track.feature2': 'Live Map Tracking',
  'track.feature3': 'Instant Alerts',
  'track.notFound.title': 'No shipment found',
  'track.notFound.desc': 'We couldn\'t find a shipment with tracking number',
  'track.notFound.hint': 'Please double-check the number or contact',
  'track.notFound.support': 'support',
  'track.found.title': 'Shipment Found',
  'track.found.private': 'Private to you',
  'track.found.viewDetails': 'View full details',
  'track.found.estDelivery': 'Est. Delivery',
  'track.found.progress': 'Progress',

  // About Page
  'about.badge': 'OUR STORY',
  'about.headline': 'Built for the Modern World of Commerce',
  'about.subtext': 'Founded in 2014, SwiftTrack started with a simple mission: make shipping as easy as sending an email. Today, we move millions of packages across 180+ countries.',
  'about.stat.founded': 'Year Founded',
  'about.stat.countries': 'Countries Served',
  'about.stat.deliveries': 'Deliveries/Year',
  'about.stat.partners': 'Business Partners',
  'about.mission.badge': 'OUR MISSION',
  'about.mission.title1': 'Connecting People,',
  'about.mission.title2': 'Delivering Possibilities',
  'about.mission.p1': 'We believe every shipment carries more than just goods. It carries trust, relationships, and the promise of something better on the other side. Our technology platform ensures that every single package — from a handwritten birthday gift to a life-saving medical device — arrives exactly when and where it should.',
  'about.mission.p2': 'We combine cutting-edge GPS tracking, AI-powered route optimization, and a network of verified carriers to give you the most reliable, transparent shipping experience in the world.',
  'about.values.title': 'The Values That Drive Us',
  'about.values.subtitle': 'Our culture is built on four pillars that guide every decision we make.',
  'about.value1.title': 'Reliability',
  'about.value1.desc': '99.7% on-time delivery backed by real-time monitoring and proactive issue resolution.',
  'about.value2.title': 'Transparency',
  'about.value2.desc': 'Full visibility at every step. No hidden fees, no surprises — just honest, clear communication.',
  'about.value3.title': 'Sustainability',
  'about.value3.desc': 'Carbon-offset fleet and optimized routing to minimize our environmental footprint.',
  'about.value4.title': 'Customer First',
  'about.value4.desc': 'Every decision we make starts with one question: how does this make things better for our clients?',
  'about.team.title1': 'Meet Our',
  'about.team.title2': 'Leadership',
  'about.team.subtitle': 'Experienced operators and technologists united by a passion for world-class logistics.',

  // Contact Page
  'contact.title': 'Get in Touch',
  'contact.subtitle': 'Questions, quotes, or feedback — our team is ready to help around the clock.',
  'contact.info.title': 'We\'re Here For You',
  'contact.info.desc': 'Reach out through any channel. Average response time is under 3 minutes for live chat, under 2 hours for email.',
  'contact.info.address': 'Address',
  'contact.info.phone': 'Phone',
  'contact.info.email': 'Email',
  'contact.info.hours': 'Support Hours',
  'contact.info.hoursVal': '24/7 — We never close',
  'contact.form.title': 'Send Us a Message',
  'contact.form.name': 'Full Name',
  'contact.form.email': 'Email Address',
  'contact.form.phone': 'Phone',
  'contact.form.subject': 'Subject',
  'contact.form.subjectPlaceholder': 'Select a subject',
  'contact.form.subjectTrack': 'Shipment Tracking Help',
  'contact.form.subjectQuote': 'Request a Quote',
  'contact.form.subjectEnterprise': 'Enterprise Solutions',
  'contact.form.subjectBilling': 'Billing Inquiry',
  'contact.form.subjectOther': 'Other',
  'contact.form.message': 'Message',
  'contact.form.send': 'Send Message',
  'contact.form.sending': 'Sending...',
  'contact.form.error': 'Something went wrong. Please try again.',
  'contact.sent.title': 'Message Sent!',
  'contact.sent.desc': 'We\'ll get back to you within 2 hours.',
  'contact.sent.another': 'Send Another',
};

export default translations;
